export default "__VITE_ASSET__684f0e57__"